import { call, put, takeLatest } from "redux-saga/effects";
import { IDieuChinhRequest } from "../../../model/request/hoa-don-dien-tu/IDieuChinhRequest";
import { IHoaDonDienTuPagingRequest } from "../../../model/request/hoa-don-dien-tu/IHoaDonDienTuPagingRequest";
import { IPhatHanhRequest } from "../../../model/request/hoa-don-dien-tu/IPhatHanhRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IBienLaiThuViewModel } from "../../../model/respone/bien-lai/IBienLaiThu";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import {
  eHoaDonDienTuActionTypeIds,
  IHoaDonDienTuActionTypes,
} from "../../action-types/hoa-don/IHoaDonDienTuAction";
import { rootActions } from "../../actions/rootActions";
import { IHoaDonDienTuView } from "../../reducer-model/hoa-don/IHoaDonDienTuReducer";
import { hoaDonDienTuApi } from "../../../api/hoa-don/hoaDonDienTuApi";

export function* hoaDonDienTuSaga(): any {
  yield takeLatest(eHoaDonDienTuActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(eHoaDonDienTuActionTypeIds.PHAT_HANH_START, phatHanhWorker);
  yield takeLatest(
    eHoaDonDienTuActionTypeIds.PHAT_HANH_NHAP_START,
    phatHanhNhapWorker
  );
  yield takeLatest(
    eHoaDonDienTuActionTypeIds.PHAT_HANH_MULTIPLE_START,
    phatHanhMultipleWorker
  );
  yield takeLatest(
    eHoaDonDienTuActionTypeIds.DIEU_CHINH_START,
    dieuChinhWorker
  );
  yield takeLatest(eHoaDonDienTuActionTypeIds.HUY_START, huyWorker);
  yield takeLatest(
    eHoaDonDienTuActionTypeIds.VIEW_DETAIL_START,
    viewDetailWorker
  );
  yield takeLatest(eHoaDonDienTuActionTypeIds.EXPORT_START, exportWorker);
  yield takeLatest(eHoaDonDienTuActionTypeIds.PREVIEW_START, previewworker);
  yield takeLatest(
    eHoaDonDienTuActionTypeIds.SYNC_STATUS_START,
    dongBoTrangThaiworker
  );
}

function* loadWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IHoaDonDienTuPagingRequest;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.SelectPaging, request);
  if (res.is_success) {
    var data = res.data as IPagingResult<IBienLaiThuViewModel[]>;
    yield put(rootActions.hoaDon.hoaDonDienTu.LOAD_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
function* dongBoTrangThaiworker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IProcessRequest<IHoaDonDienTuPagingRequest>;
  const res: IBaseRespone = yield call(
    hoaDonDienTuApi.DongBoTrangThai,
    request
  );
  if (res.is_success) {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.SYNC_STATUS_SUCCESS("Thành công")
    );
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.SYNC_STATUS_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* phatHanhWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IPhatHanhRequest;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.PhatHanh, request);
  if (res.is_success) {
    var data = res.data as string;
    yield put(rootActions.hoaDon.hoaDonDienTu.PHAT_HANH_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.PHAT_HANH_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* phatHanhNhapWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IPhatHanhRequest;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.PhatHanhNhap, request);
  if (res.is_success) {
    var data = res.data as string;
    yield put(rootActions.hoaDon.hoaDonDienTu.PHAT_HANH_NHAP_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.PHAT_HANH_NHAP_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* phatHanhMultipleWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IProcessRequest<IPhatHanhRequest[]>;
  const res: IBaseRespone = yield call(
    hoaDonDienTuApi.PhatHanhMultiple,
    request
  );
  if (res.is_success) {
    var data = res.data as string;
    yield put(rootActions.hoaDon.hoaDonDienTu.PHAT_HANH_MULTIPLE_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.PHAT_HANH_MULTIPLE_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* dieuChinhWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IDieuChinhRequest;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.DieuChinh, request);
  if (res.is_success) {
    var data = res.data as string;
    yield put(rootActions.hoaDon.hoaDonDienTu.DIEU_CHINH_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.DIEU_CHINH_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* huyWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as number;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.Huy, request);
  if (res.is_success) {
    var data = res.data as string;
    yield put(rootActions.hoaDon.hoaDonDienTu.HUY_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.HUY_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* viewDetailWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IPhatHanhRequest;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.XemChiTiet, request);
  if (res.is_success) {
    var data = res.data as IHoaDonDienTuView;
    yield put(rootActions.hoaDon.hoaDonDienTu.VIEW_DETAIL_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.VIEW_DETAIL_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* exportWorker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as number;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.ExportPDF, request);
  if (res.is_success) {
    var data = res.data as string;
    yield put(rootActions.hoaDon.hoaDonDienTu.EXPORT_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.EXPORT_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* previewworker(action: IHoaDonDienTuActionTypes): any {
  const request = action.payload as IPhatHanhRequest;
  const res: IBaseRespone = yield call(hoaDonDienTuApi.Preview, request);
  if (res.is_success) {
    var data = res.data as IHoaDonDienTuView;
    yield put(rootActions.hoaDon.hoaDonDienTu.PREVIEW_SUCCESS(data));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDienTu.PREVIEW_ERRR(res.message ?? "Có lỗi")
    );
  }
}
